<div *ngIf="business.description || (editModeSet && !isAmbassador)" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Club Description <mat-icon (click)="openEditDescDialog()" *ngIf="editModeSet && !isAmbassador" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content flying-club__content" *ngIf="business.description; else please">
      {{ business.description }}
    </div>
  </div>
</div>

<div *ngIf="hasClubFeatureData || (editModeSet && !isAmbassador)" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Club Features</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isAmbassador">Facilities:
          <mat-icon (click)="openEditFeaturesDialog(['Flying Club::Benefits::'],'Facilities')" *ngIf="editModeSet && !isAmbassador" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="facilitiesTags.length; else nonePlaceholder" [items]="facilitiesTags"></app-tag-bullet-list>
        </div>
      </div>
      <div *ngIf="typesOfFlyingTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isAmbassador">Types of Flying:
          <mat-icon (click)="openEditFeaturesDialog(['Flying Club::Flying::'],'Types of Flying')" *ngIf="editModeSet && !isAmbassador" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="typesOfFlyingTags.length; else nonePlaceholder" [items]="typesOfFlyingTags"></app-tag-bullet-list>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="hasClubDetailData || (editModeSet && !isAmbassador)" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Club Details
      <mat-icon (click)="openEditDetailsDialog()" *ngIf="editModeSet && !isAmbassador" class="edit-icon">edit</mat-icon>
    </h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div class="data-block__item">
        <div class="data-block__label">AOPA Network Club:</div>
        <div class="data-block__value">
          {{ hasTag(business.tags, 'Flying Club::AOPA::AOPA Network') | boolean }}
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Organization Type:</div>
        <div class="data-block__value">
          {{ hasTag(business.tags, 'Flying Club::Equity Club') ? 'Profit' : 'Not-for-Profit' }}
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Average Membership Size:</div>
        <div class="data-block__value">
          <ng-container *ngIf="business.flyingClub.clubMembers; else unknown">
            {{ business.flyingClub.clubMembers }}
          </ng-container>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Number of Aircraft:</div>
        <div class="data-block__value">
          <ng-container *ngIf="business.flyingClub.clubAircraft; else unknown">
            {{ business.flyingClub.clubAircraft }}
          </ng-container>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Memberships Currently Available:</div>
        <div class="data-block__value">
          {{ hasTag(business.tags, 'Flying Club::Membership::Open') ? 'Yes'
          : hasTag(business.tags, 'Flying Club::Membership::Waiting List') ? 'Waiting List. Please contact club for details.' : 'Unknown' }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #unknown>
  <div class="business-global-block__value">Unknown</div>
</ng-template>


<ng-template #please>
  <div class="section__content flying-club__content">None Entered</div>
</ng-template>


<ng-template #nonePlaceholder>
  <div *ngIf="editModeSet && !isAmbassador"><p>None Selected</p></div>
  <div *ngIf="!editModeSet || isAmbassador"><p>None Reported</p></div>
</ng-template>

